// hoks
import { useAuthenticationContext } from "../contexts/authentication/authentication.context";
import { useQuery } from "@tanstack/react-query";

// utilities
import { Time } from "wombat-global/src/utilities/time";

// types
import { IClientTarget, ISiteTarget } from "wombat-global/src/typings";
import { uniqueTargetString } from "wombat-global/src/utilities";

export function useIsAdmin(
  target: IClientTarget | ISiteTarget | undefined,
): [boolean, boolean] {
  const { uid, isAdmin } = useAuthenticationContext();
  const { data: _isAdmin, isLoading } = useQuery({
    queryKey: ["is-admin", target ? uniqueTargetString(target) : "wombat", uid],
    staleTime: 5 * Time.mins,
    networkMode: "offlineFirst",
    queryFn: () => isAdmin(target),
    refetchOnMount(q) {
      return q.isStale();
    },
  });

  return [_isAdmin || false, isLoading];
}
